module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAATCAYAAABPwleqAAABX0lEQVQ4jZXSvWtUQRTG4Wcv2wgWihD8CEyagJ3cygELjSISrGIpQnrBTnutJCiW2oqFaOMfYCFaOSjuhWAhWOg0KQQhEJEtxLXYEZbN3MC+zRnOeX9nznwMJpOJeaUuX8dNHMEuHsc2PJ/3Debh1OUHuL2vIw9jG+70wqnLm3iKX7iFb1jFEwyxGdvwbB+cunwIX3EC52Ib0kzT83iDHazGNoyhmZniOE5hNAtCbMM7jLBcmpuHd0vMlfPO5v/7DMtYS7hSciupy+ul1uAv/mCl1K+mLr+ObfgxeD/6fhavcLJnx5p2cK3B1oKg4t9qTC+hpo+4hw899eUG40phG5diG+5iDZ8qnnFTScLn2IY9iG34jS81Ux+8nrocIXX5DC4vAh/FRlnfwNIiMOyV+LPP0CgfpaKLqcunTS+syg5Nf09Na6bPdbgPbvCib6wDQHg5xCMcw4UDjPN6i/v/AOrXYn3EGyLfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/password.png
// module id = +OFU
// module chunks = 1